import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import SEOMeta from '@/components/base/SEOMeta';
import SEOData from '@/components/base/SEOData';
import { comics, categories, testimonials, faqs, platformStats } from '@/mocks/comics';

function HomeSEO() {
  return (
    <>
      <SEOMeta
        title="免费韩漫-韩国漫画下拉式在线阅读-高清漫画大全-韩漫漫画网"
        description="在韩漫漫画网体验免费韩漫阅读，享受韩国漫画下拉式在线阅读与高清漫画大全，专业服务品质保证。"
        keywords="免费韩漫,韩国漫画下拉式,在线阅读,高清漫画大全,韩漫漫画网"
        canonicalUrl="http://aetws.cn/"
      />
      <SEOData type="WebSite" data={{
        name: '韩漫漫画网',
        url: 'http://aetws.cn/',
        description: '在韩漫漫画网体验免费韩漫阅读，享受韩国漫画下拉式在线阅读与高清漫画大全，专业服务品质保证。',
        inLanguage: 'zh-CN',
      }} />
      <SEOData type="Organization" data={{
        name: '韩漫漫画网',
        url: 'http://aetws.cn/',
        description: '免费韩漫在线阅读平台',
        sameAs: ['http://aetws.cn/', 'http://aetws.cn/'],
      }} />
      <SEOData type="FAQPage" data={{
        mainEntity: faqs.map(f => ({
          '@type': 'Question',
          name: f.question,
          acceptedAnswer: { '@type': 'Answer', text: f.answer },
        })),
      }} />
    </>
  );
}

export default function Home() {
  const hotComics = comics.filter(c => c.rating >= 9.0).slice(0, 6);
  const latestComics = comics.slice(0, 6);

  return (
    <>
      <HomeSEO />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20artistic%20illustration%2C%20epic%20fantasy%20landscape%20with%20warm%20golden%20light%2C%20mystical%20ancient%20temple%20ruins%20with%20floating%20magical%20particles%2C%20soft%20dreamy%20atmosphere%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20cinematic%20composition%2C%20painterly%20texture%2C%20beautiful%20scenery%20with%20depth%20of%20field&width=1920&height=1080&seq=hero-bg-home&orientation=landscape"
              alt="韩漫漫画网 - 免费韩国漫画在线阅读"
              title="韩漫漫画网"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
          </div>
          <div className="relative z-10 w-full h-full flex items-center">
            <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8">
              <div className="max-w-2xl">
                <h1 className="font-heading text-4xl md:text-6xl font-bold text-background-50 leading-tight mb-4">
                  免费韩漫<br />高清下拉式<br />在线阅读
                </h1>
                <p className="text-background-50/80 text-base md:text-lg mb-8 max-w-lg leading-relaxed">
                  海量韩国漫画免费看，流畅下拉式阅读体验，每日更新热门韩漫
                </p>
                <Link
                  to="/category/remen"
                  className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-7 py-3.5 rounded-full text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  立即开始阅读 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
        </section>

        {/* Hot Comics Grid */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8">
            <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10">
              <div>
                <p className="text-accent-500 text-sm font-medium mb-2">精选推荐</p>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
                  热门韩国漫画
                </h2>
                <p className="text-foreground-500 text-sm mt-2 max-w-md">
                  精选全网评分最高的韩漫作品，每一部都值得细细品味
                </p>
              </div>
              <Link
                to="/category/remen"
                className="text-foreground-600 text-sm font-medium hover:text-accent-500 transition-colors mt-4 lg:mt-0 whitespace-nowrap flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {hotComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </section>

        {/* Feature Grid */}
        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1.5 border border-foreground-300 rounded-full text-sm text-foreground-600 mb-4 whitespace-nowrap">
                阅读特色
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                为什么选择<br />韩漫漫画网
              </h2>
              <p className="text-foreground-500 text-sm max-w-lg mx-auto">
                专为漫画爱好者打造的极致阅读体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                {
                  icon: 'ri-smartphone-line',
                  title: '下拉式阅读',
                  desc: '专为移动端优化的下拉式阅读体验，流畅翻页，沉浸式享受每一话漫画。',
                },
                {
                  icon: 'ri-image-line',
                  title: '高清画质',
                  desc: '全部漫画采用高清画质呈现，细节清晰，色彩饱满，还原最佳视觉效果。',
                },
                {
                  icon: 'ri-timer-flash-line',
                  title: '极速更新',
                  desc: '热门漫画每日同步更新，第一时间带来最新章节，永远快人一步。',
                },
                {
                  icon: 'ri-bookmark-line',
                  title: '完全免费',
                  desc: '所有漫画资源完全免费，无需注册付费，打开即看，畅享海量韩漫。',
                },
              ].map((feature, i) => (
                <div
                  key={i}
                  className="group rounded-2xl bg-background-50 p-6 md:p-7 transition-all duration-300 hover:bg-accent-500 hover:text-background-50 cursor-pointer"
                >
                  <div className="w-12 h-12 rounded-xl bg-background-200 flex items-center justify-center mb-5 group-hover:bg-background-50/20">
                    <i className={`${feature.icon} text-foreground-700 text-xl group-hover:text-background-50`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 group-hover:text-background-50 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-foreground-500 group-hover:text-background-50/80 leading-relaxed">
                    {feature.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-foreground-600 group-hover:text-background-50 mt-4 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    了解更多 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categories Navigation */}
        <section className="w-full py-14 md:py-16 bg-background-50">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
              漫画分类
            </h2>
            <div className="flex flex-wrap justify-center gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 hover:bg-accent-500 hover:text-background-50 text-foreground-700 text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* About Platform */}
        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
              <div className="lg:w-1/2">
                <p className="text-accent-500 text-sm font-medium mb-3">关于我们</p>
                <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
                  打造最优质的<br />韩漫阅读平台
                </h2>
                <p className="text-foreground-500 text-sm leading-relaxed mb-6 max-w-lg">
                  韩漫漫画网成立于{new Date().getFullYear() - platformStats.yearsActive}年，{platformStats.yearsActive}年来始终坚持为漫画爱好者提供免费的韩国漫画阅读服务。我们拥有超过{platformStats.totalComics.toLocaleString()}部漫画作品，{platformStats.totalChapters.toLocaleString()}个章节，每日服务{platformStats.dailyVisitors.toLocaleString()}位读者。
                </p>
                <div className="flex flex-wrap gap-6">
                  {[
                    { num: `${platformStats.totalComics.toLocaleString()}+`, label: '漫画作品' },
                    { num: `${(platformStats.dailyVisitors / 10000).toFixed(0)}万+`, label: '日活跃用户' },
                    { num: `${platformStats.yearsActive}年`, label: '运营时长' },
                  ].map((stat) => (
                    <div key={stat.label}>
                      <div className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">{stat.num}</div>
                      <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="lg:w-1/2 flex gap-4">
                <div className="w-2/5 aspect-[3/4] rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%2C%20young%20female%20character%20reading%20a%20book%20in%20cozy%20cafe%2C%20warm%20soft%20lighting%2C%20gentle%20atmosphere%2C%20cream%20and%20beige%20color%20palette%2C%20clean%20composition%2C%20professional%20illustration%2C%20relaxing%20vibe&width=600&height=800&seq=about-img-01&orientation=portrait"
                    alt="韩漫阅读体验"
                    title="韩漫阅读体验"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-3/5 aspect-[3/4] rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%2C%20fantasy%20adventure%20scene%20with%20characters%20exploring%20ancient%20ruins%2C%20warm%20golden%20sunlight%2C%20mystical%20atmosphere%2C%20soft%20earth%20tones%2C%20cream%20and%20warm%20brown%20palette%2C%20clean%20cinematic%20composition%2C%20professional%20illustration&width=800&height=1067&seq=about-img-02&orientation=portrait"
                    alt="韩漫漫画网 - 海量漫画"
                    title="韩漫漫画网 - 海量漫画"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8">
            <div className="bg-primary-500 rounded-[2rem] relative overflow-hidden p-8 md:p-14">
              <div className="absolute top-0 left-8 text-background-50/8 text-[180px] font-display leading-none select-none">&ldquo;</div>
              <div className="relative z-10 flex flex-col lg:flex-row gap-10 items-center">
                <div className="lg:w-2/5 flex justify-center">
                  <div className="w-64 h-80 md:w-72 md:h-96 rounded-2xl overflow-hidden -mt-20 md:-mt-24 lg:-mb-14">
                    <img
                      src={testimonials[0].avatar}
                      alt={testimonials[0].name}
                      title={testimonials[0].name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="lg:w-3/5 text-background-50">
                  <div className="text-6xl md:text-7xl font-display text-background-50/20 leading-none mb-4">&ldquo;</div>
                  <blockquote className="text-lg md:text-xl leading-relaxed mb-6">
                    {testimonials[0].content}
                  </blockquote>
                  <div className="mb-5">
                    <p className="font-heading text-lg font-semibold">{testimonials[0].name}</p>
                    <p className="text-sm text-background-50/60">{testimonials[0].role}</p>
                  </div>
                  <Link
                    to="/category/remen"
                    className="inline-flex items-center gap-2 bg-accent-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    开始阅读 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="w-full max-w-[1000px] mx-auto px-4 md:px-8">
            <div className="rounded-[1.5rem] overflow-hidden mb-10">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20open%20books%20and%20floating%20pages%20with%20magical%20glow%2C%20warm%20cream%20and%20golden%20color%20palette%2C%20dreamy%20atmosphere%2C%20soft%20lighting%2C%20clean%20elegant%20composition%2C%20painterly%20texture%2C%20literary%20and%20fantasy%20theme%2C%20beautiful%20minimalist%20style&width=1600&height=600&seq=cta-banner-home&orientation=landscape"
                alt="开始阅读韩漫"
                title="开始阅读韩漫"
                className="w-full h-[200px] md:h-[300px] object-cover"
              />
            </div>
            <div className="text-center">
              <p className="font-display italic text-3xl md:text-4xl text-foreground-700 mb-3">
                准备好了吗？
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-2">
                开启你的<span className="font-display italic text-foreground-500">韩漫</span>之旅
              </h2>
              <p className="text-foreground-400 text-3xl md:text-4xl lg:text-5xl font-bold font-heading">
                就在今天
              </p>
              <Link
                to="/category/remen"
                className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-4 rounded-full text-base font-medium mt-8 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                免费开始阅读 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="w-full max-w-[900px] mx-auto px-4 md:px-8">
            <div className="text-center mb-10">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-foreground-500 text-sm">
                关于韩漫漫画网，你可能想知道的
              </p>
            </div>
            <div className="space-y-3">
              {faqs.map((faq, i) => (
                <details key={i} className="group rounded-xl bg-background-50 overflow-hidden cursor-pointer">
                  <summary className="flex items-center justify-between px-6 py-5 font-medium text-foreground-950 text-sm list-none">
                    {faq.question}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-300 text-lg"></i>
                  </summary>
                  <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}